import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRepoFilesArgs, SearchRepoFilesOutput } from "types/generated";

export const GET_SPACELIFT_VCS_FILES: TypedDocumentNode<
  { searchRepoFiles: SearchRepoFilesOutput },
  QuerySearchRepoFilesArgs
> = gql`
  query GetSpaceliftVcsFiles($repoID: ID!, $commit: String, $input: SearchInput!) {
    searchRepoFiles(repoID: $repoID, commit: $commit, input: $input) {
      edges {
        cursor
        node {
          filePath
          isDeleted
          sizeBytes
          fileMode
          content {
            content
            isEncrypted
          }
          revision {
            id
            sha
            message
            authorName
            createdAt
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
